import React from 'react';

export default class Categories extends React.Component {

    constructor(props) {
		super(props);
		this.state = {
		};
    }

	selectCategory(ev,id) {
		ev.preventDefault();
		this.props.selectCategory(id);
	}
	
	getSortedItems() {
		return this.props.cats.sort(function(a, b){
			if(a.title < b.title) { return -1; }
			if(a.title > b.title) { return 1; }
			return 0;
		});
	}

	render() {
		return (
			<div class="search-form">
				<div class="text-choose">или выберите по категории товаров/услуг:</div>
				<ul class="list-categories">
					{this.getSortedItems().map((cat,index) => {
						return (
							<li class="list-categories_item" key={index}>
								<a class="list-categories_link" href="#" onClick={e => this.selectCategory(e,cat.id)}>
									<span class={'icon-' + cat.icon + ' list-categories_icon'}></span>
									{cat.title}
									<span class="list-categories_qty">{cat.count}</span>
								</a>
							</li>
						)
					})}
				</ul>
			</div>
		);
	}

}